// src/configuracion.ts
var TRANSPORTES = ["webusb", "web-serial", "web-bluetooth", "qz-tray", "ninguno"];
var ANCHOS_PAPEL = [80, 58];
var BAUDIOS = [9600, 19200, 38400, 57600, 115200];
var PAPELES = ["ticket", "etiqueta", "a4"];
var LENGUAJES = ["escpos", "tspl", "zpl", "driver"];
var CODIFICACIONES = ["cp858", "cp850", "windows1252", "cp437"];
var DENSIDADES = [
  { valor: null, etiqueta: "La de la impresora" },
  { valor: 4, etiqueta: "Clara" },
  { valor: 8, etiqueta: "Normal" },
  { valor: 12, etiqueta: "Oscura" },
  { valor: 15, etiqueta: "Muy oscura" }
];
var MEDIDAS_ETIQUETA = [
  { anchoMm: 100, altoMm: 150 },
  { anchoMm: 100, altoMm: 100 },
  { anchoMm: 100, altoMm: 60 },
  { anchoMm: 60, altoMm: 40 },
  { anchoMm: 50, altoMm: 30 }
];
var CONFIGURACION_IMPRESORA_POR_DEFECTO = {
  transporte: "ninguno",
  ancho: 58,
  sinAcentos: false,
  imprimirAlEntregar: false,
  imprimirAlRecibir: false,
  baudios: 9600,
  qzImpresora: null,
  bluetoothId: null,
  bluetoothNombre: null,
  papel: "ticket",
  etiqueta: { anchoMm: 100, altoMm: 60 },
  lenguaje: "escpos",
  codificacion: "cp858",
  cortar: true,
  densidad: null,
  usb: null,
  serie: null
};
var NOMBRE_TRANSPORTE = {
  webusb: "USB directo",
  "web-serial": "USB o puerto serie",
  "web-bluetooth": "Bluetooth",
  "qz-tray": "Cualquier impresora de esta computadora (QZ Tray)",
  ninguno: "Preguntar con el diálogo del navegador"
};
var AYUDA_TRANSPORTE = {
  webusb: "La térmica enchufada por USB que Windows no tiene instalada como impresora, o el celular Android con cable OTG. Chrome o Edge.",
  "web-serial": "La térmica USB que Windows ve como puerto COM, o una serie de verdad. Chrome o Edge en la computadora.",
  "web-bluetooth": 'Térmica Bluetooth BLE (4.0 o más nueva), en Chrome para Android o en la computadora. Las Bluetooth "clásicas" no aparecen.',
  "qz-tray": "Con el programa QZ Tray instalado imprime en cualquier impresora de esta computadora: la térmica con su driver, una de red (IP:9100), la de etiquetas o la A4.",
  ninguno: 'Cada impresión abre el diálogo del navegador para elegir la impresora o "Guardar como PDF". Sirve siempre, pero no imprime sola.'
};
var NOMBRE_PAPEL = {
  ticket: "Rollo de ticket",
  etiqueta: "Etiquetas",
  a4: "Hoja A4"
};
var NOMBRE_LENGUAJE = {
  escpos: "ESC/POS (térmicas de tickets)",
  tspl: "TSPL (TSC, Xprinter y otras de etiquetas)",
  zpl: "ZPL (Zebra)",
  driver: "Con el driver de la impresora (como imagen)"
};
var NOMBRE_CODIFICACION = {
  cp858: "PC858: tildes, eñe y € (la más común)",
  cp850: "PC850: tildes y eñe (las más viejas)",
  windows1252: "Windows 1252",
  cp437: "PC437: sin tildes en mayúscula"
};
var CLAVE = "reparto:impresora";
var enteroEn = (v, min, max) => typeof v === "number" && Number.isInteger(v) && v >= min && v <= max ? v : null;
function normalizarImpresora(crudo, porDefecto = {}) {
  const d = { ...CONFIGURACION_IMPRESORA_POR_DEFECTO, ...porDefecto };
  const o = typeof crudo === "object" && crudo !== null ? crudo : {};
  const texto = (v, def) => typeof v === "string" && v ? v : def;
  const bool = (v, def) => typeof v === "boolean" ? v : def;
  const etiqueta = o.etiqueta ?? {};
  const usb = o.usb;
  const serie = o.serie;
  const usbVendor = usb ? enteroEn(usb.vendorId, 0, 65535) : null;
  const usbProducto = usb ? enteroEn(usb.productId, 0, 65535) : null;
  return {
    transporte: TRANSPORTES.includes(o.transporte) ? o.transporte : d.transporte,
    ancho: o.ancho === 58 || o.ancho === 80 ? o.ancho : d.ancho,
    sinAcentos: bool(o.sinAcentos, d.sinAcentos),
    imprimirAlEntregar: bool(o.imprimirAlEntregar, d.imprimirAlEntregar),
    imprimirAlRecibir: bool(o.imprimirAlRecibir, d.imprimirAlRecibir),
    baudios: enteroEn(o.baudios, 300, 1e6) ?? d.baudios,
    qzImpresora: texto(o.qzImpresora, d.qzImpresora),
    bluetoothId: texto(o.bluetoothId, d.bluetoothId),
    bluetoothNombre: texto(o.bluetoothNombre, d.bluetoothNombre),
    papel: PAPELES.includes(o.papel) ? o.papel : d.papel,
    etiqueta: {
      anchoMm: enteroEn(etiqueta.anchoMm, 20, 120) ?? d.etiqueta.anchoMm,
      altoMm: enteroEn(etiqueta.altoMm, 15, 300) ?? d.etiqueta.altoMm
    },
    lenguaje: LENGUAJES.includes(o.lenguaje) ? o.lenguaje : d.lenguaje,
    codificacion: CODIFICACIONES.includes(o.codificacion) ? o.codificacion : d.codificacion,
    cortar: bool(o.cortar, d.cortar),
    densidad: o.densidad === null ? null : enteroEn(o.densidad, 0, 15) ?? d.densidad,
    usb: usbVendor !== null && usbProducto !== null ? { vendorId: usbVendor, productId: usbProducto, serie: texto(usb?.serialNumber ?? usb?.serie, null) } : d.usb,
    serie: serie ? {
      usbVendorId: enteroEn(serie.usbVendorId, 0, 65535),
      usbProductId: enteroEn(serie.usbProductId, 0, 65535)
    } : d.serie
  };
}
function leerConfiguracionImpresora(porDefecto = {}) {
  let crudo = null;
  try {
    crudo = JSON.parse(localStorage.getItem(CLAVE));
  } catch {
  }
  return normalizarImpresora(crudo, porDefecto);
}
function guardarConfiguracionImpresora(c) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(c));
  } catch {
  }
}
var CLAVE_VARIAS = "reparto:impresoras";
var CONFIGURACION_IMPRESORAS_VACIA = {
  version: 2,
  impresoras: [],
  asignacion: {},
  imprimirAlRecibir: false,
  dialogoSinPreguntar: false
};
function idImpresora() {
  const c = globalThis.crypto;
  return c?.randomUUID ? c.randomUUID() : `imp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
function nombreSugerido(c) {
  if (c.papel === "etiqueta") return "Etiquetas";
  if (c.papel === "a4") return "Impresora A4";
  if (c.transporte === "ninguno") return "Impresora del navegador";
  return c.transporte === "web-bluetooth" ? "Térmica Bluetooth" : "Térmica";
}
function nuevaImpresora(datos = {}, porDefecto = {}) {
  const c = normalizarImpresora(datos, porDefecto);
  return { ...c, id: datos.id || idImpresora(), nombre: datos.nombre?.trim() || nombreSugerido(c) };
}
function migrarConfiguracionImpresora(vieja, porDefecto = {}) {
  if (typeof vieja !== "object" || vieja === null) return { ...CONFIGURACION_IMPRESORAS_VACIA, impresoras: [] };
  const c = normalizarImpresora(vieja, porDefecto);
  return {
    version: 2,
    impresoras: [nuevaImpresora({ ...c, id: "principal" }, porDefecto)],
    asignacion: {},
    imprimirAlRecibir: c.imprimirAlRecibir,
    dialogoSinPreguntar: false
  };
}
function normalizarImpresoras(crudo, porDefecto = {}) {
  const o = typeof crudo === "object" && crudo !== null ? crudo : {};
  const vistas = /* @__PURE__ */ new Set();
  const impresoras = [];
  for (const i of Array.isArray(o.impresoras) ? o.impresoras : []) {
    if (typeof i !== "object" || i === null) continue;
    const x = i;
    const id = typeof x.id === "string" && x.id ? x.id : idImpresora();
    if (vistas.has(id)) continue;
    vistas.add(id);
    impresoras.push(nuevaImpresora({ ...x, id }, porDefecto));
  }
  const asignacion = {};
  for (const [doc, id] of Object.entries(o.asignacion ?? {}))
    if (typeof id === "string" && vistas.has(id)) asignacion[doc] = id;
  return {
    version: 2,
    impresoras,
    asignacion,
    imprimirAlRecibir: o.imprimirAlRecibir === true,
    dialogoSinPreguntar: o.dialogoSinPreguntar === true
  };
}
function leerImpresoras(porDefecto = {}) {
  try {
    const nueva = localStorage.getItem(CLAVE_VARIAS);
    if (nueva !== null) return normalizarImpresoras(JSON.parse(nueva), porDefecto);
    const vieja = localStorage.getItem(CLAVE);
    const migrada = migrarConfiguracionImpresora(vieja === null ? null : JSON.parse(vieja), porDefecto);
    if (migrada.impresoras.length) guardarImpresoras(migrada);
    return migrada;
  } catch {
    return { ...CONFIGURACION_IMPRESORAS_VACIA, impresoras: [] };
  }
}
function guardarImpresoras(c) {
  try {
    localStorage.setItem(CLAVE_VARIAS, JSON.stringify(c));
  } catch {
  }
}
function impresoraDe(c, documento) {
  const id = c.asignacion[documento];
  return c.impresoras.find((i) => i.id === id) ?? c.impresoras[0] ?? null;
}
function documentosDe(c, impresoraId, documentos) {
  return documentos.filter((d) => impresoraDe(c, d)?.id === impresoraId);
}
function quitarImpresora(c, id) {
  const asignacion = Object.fromEntries(Object.entries(c.asignacion).filter(([, v]) => v !== id));
  return { ...c, impresoras: c.impresoras.filter((i) => i.id !== id), asignacion };
}
function opcionesDocumento(c) {
  if (c.papel === "ticket") return { ancho: c.ancho, sinAcentos: c.sinAcentos };
  const ancho = c.papel === "a4" ? 80 : c.etiqueta.anchoMm >= 70 ? 80 : 58;
  return { ancho, sinAcentos: c.sinAcentos, lineasFinales: 0 };
}
function hojaDeImpresora(c) {
  if (c.papel === "etiqueta")
    return { anchoMm: c.etiqueta.anchoMm, altoMm: c.etiqueta.altoMm, margenMm: 2, maxEscala: 1.6 };
  if (c.papel === "a4") return { anchoMm: 210, altoMm: 297, margenMm: 15, maxEscala: 1.5 };
  return null;
}
function conexionCompatible(c) {
  const comoImagen = c.papel === "a4" || c.lenguaje === "driver";
  return !comoImagen || c.transporte === "qz-tray" || c.transporte === "ninguno";
}
function esIos(nav) {
  if (!nav) return false;
  const ua = nav.userAgent ?? "";
  return /iPhone|iPad|iPod/.test(ua) || nav.platform === "MacIntel" && (nav.maxTouchPoints ?? 0) > 1;
}
function transportesDisponibles() {
  const nav = typeof navigator === "undefined" ? null : navigator;
  return {
    ninguno: true,
    "qz-tray": nav !== null && !esIos(nav),
    "web-serial": nav !== null && "serial" in nav,
    webusb: nav !== null && "usb" in nav,
    "web-bluetooth": nav !== null && "bluetooth" in nav
  };
}

export {
  TRANSPORTES,
  ANCHOS_PAPEL,
  BAUDIOS,
  PAPELES,
  LENGUAJES,
  CODIFICACIONES,
  DENSIDADES,
  MEDIDAS_ETIQUETA,
  CONFIGURACION_IMPRESORA_POR_DEFECTO,
  NOMBRE_TRANSPORTE,
  AYUDA_TRANSPORTE,
  NOMBRE_PAPEL,
  NOMBRE_LENGUAJE,
  NOMBRE_CODIFICACION,
  normalizarImpresora,
  leerConfiguracionImpresora,
  guardarConfiguracionImpresora,
  CONFIGURACION_IMPRESORAS_VACIA,
  idImpresora,
  nombreSugerido,
  nuevaImpresora,
  migrarConfiguracionImpresora,
  normalizarImpresoras,
  leerImpresoras,
  guardarImpresoras,
  impresoraDe,
  documentosDe,
  quitarImpresora,
  opcionesDocumento,
  hojaDeImpresora,
  conexionCompatible,
  esIos,
  transportesDisponibles
};
//# sourceMappingURL=chunk-IX4ED2ZW.js.map